import { MessageBar, MessageBarType, Separator, Stack, Text } from '@fluentui/react';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '../../common/components/tooltip/InfoTooltip';
import cardStyles from '../../../theme/styles/Card.module.css';
import { useZoomAuth } from './useZoomAuth';

const ZoomSettings: FC = () => {
  const { t } = useTranslation();
  const { isZoomAuthed, isLoading, isTokenLoading, handleZoomConnect } = useZoomAuth();

  return (
    <div className={cardStyles.card}>
      <div className={cardStyles.card_content}>
        <div style={{ marginTop: 8, marginBottom: 12 }}>
          <Separator>
            <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
              <Text variant="mediumPlus" style={{ fontWeight: 'bold' }}>
                {t('zoomAuthentication')}
              </Text>
              <div style={{ height: 16 }}>
                <InfoTooltip infoContent={t('zoomAuthenticationTooltip')} />
              </div>
            </Stack>
          </Separator>
        </div>

        <MessageBar
          role="status"
          actions={
            <div>
              <PrimaryButton
                disabled={isLoading || isTokenLoading}
                text={isZoomAuthed ? t('reconnect') : t('connect')}
                onClick={handleZoomConnect}
              />
            </div>
          }
          messageBarType={isZoomAuthed ? MessageBarType.success : MessageBarType.warning}
          isMultiline={false}
          styles={{
            content: {
              display: 'flex',
              alignItems: 'center',
            },
            innerText: {
              lineHeight: 20,
            },
            root: {
              paddingTop: 8,
              paddingBottom: 8,
            },
          }}
        >
          <Text block variant="mediumPlus" style={{ fontWeight: 'bold' }}>
            {isZoomAuthed ? t('zoomConnectionSuccess') : t('zoomConnectionRequired')}
          </Text>
        </MessageBar>
      </div>
    </div>
  )
};

export default ZoomSettings;